/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

export const APP_NAV_BUTTON_BASE_CLASS = 'btn btn-sm rounded-full border px-4 text-sm font-medium normal-case transition-colors';

export const APP_NAV_BUTTON_ACTIVE_CLASS = 'border-base-content bg-base-content text-base-100 hover:border-base-content hover:bg-base-content hover:text-base-100';

export const APP_NAV_BUTTON_INACTIVE_CLASS = 'border-transparent btn-ghost text-base-content/70 hover:border-base-content/10 hover:bg-base-content/10 hover:text-base-content';

export const APP_NAV_SEGMENTED_BUTTON_BASE_CLASS = 'btn btn-sm join-item flex-1 border-base-300 px-3 shadow-none transition-colors hover:shadow-none';

export const APP_NAV_SEGMENTED_BUTTON_ACTIVE_CLASS = 'border-neutral-content bg-neutral-content text-base-100 hover:border-neutral-content hover:bg-neutral-content hover:text-base-100';

export const APP_NAV_SEGMENTED_BUTTON_INACTIVE_CLASS = 'bg-base-100 text-base-content/70 hover:border-neutral-content hover:bg-neutral-content hover:text-base-content';

export const APP_NAV_MENU_ITEM_CLASS = 'flex items-center gap-2 whitespace-nowrap text-sm font-medium';

export const APP_NAV_MENU_DISABLED_CLASS = `${APP_NAV_MENU_ITEM_CLASS} cursor-not-allowed text-base-content/40`;
